<template>
   <PrimeToast />
   <HeaderComponent></HeaderComponent>
   <section>
      <div class="container pt-3 pb-3">
         <div class="row align-items-center">
            <div class="col-lg-12">
               <router-view></router-view>
            </div>
         </div>
      </div>
   </section>
   <FooterComponent></FooterComponent>
</template>

<script>
import HeaderComponent from "./components/HeaderComponent.vue";
import FooterComponent from "./components/FooterComponent.vue";

export default {
   name: "App",
   components: {
      HeaderComponent,
      FooterComponent,
   },
};
</script>
